import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import useFirebaseNotifications from 'hooks/useFirebaseNotifications';

import { selectors } from 'redux/auth';

export default function PrivateRoute({ component: Component, ...rest }) {
  const isLoggedIn = useSelector(selectors.getAuth);

  useFirebaseNotifications(isLoggedIn);

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location === '/login' ? '/' : props.location }
            }}
          />
        )
      }
    />
  );
}
